import React, {useEffect, useState} from 'react';
import Layout from './components/Layout';
import Unauthorized from './components/Unauthorized';
import Page from './pages/Page';
import CreateUser from './pages/users/CreateUser';
import EditUser from './pages/users/EditUser';
import UserList from './pages/users/UserList';
import EditTeam from './pages/teams/EditTeam';
import ManageTeams from './pages/teams/ManageTeams';
import ManageDocuments from './pages/ManageDocuments';
import Settings from './pages/Settings';
import LoginForm from './pages/LoginForm';
import LoginAgent from './pages/LoginAgent';
import RequireAuth from './components/RequireAuth';

import {Routes, Route, useNavigate, useLocation} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from './config/configJS';
import {MsalProvider, useIsAuthenticated, useMsal} from "@azure/msal-react";
import {InteractionStatus, PublicClientApplication} from "@azure/msal-browser";
import CreateTeam from './pages/teams/CreateTeam';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import axios from "./api/axios";
import useAuth from "./hooks/useAuth";
import {getEnvironmentsforUser} from "./api/documentAPI";
import useCookie from "./hooks/useCookie";
import { useNotification } from './context/NotificationContext';
import { NotificationType } from './enums/NotificationType';



function App() {
  const [t] = useTranslation('global');
  const { showNotification } = useNotification();
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { setAuth } = useAuth();
  const [envCookie, setEnvCookie, ] = useCookie("ENV");
  const navigate = useNavigate();
  const location = useLocation();
  const [initializing, setInitializing] = useState(true);
  const from = location.state?.from?.pathname || "/";

  const handlePostLogin = async (user) => {

    console.log('handlePostLogin', user);
    const { id, userFirstname, userLastname, userEmail, isActive, roleId, authMethod, accesses } = user;
    setAuth({
      uid: id,
      ufn: userFirstname,
      uln: userLastname,
      uem: userEmail,
      uia: isActive,
      uri: roleId,
      uam: authMethod,
      uac: accesses
    });

    await validateAndSetCookie();

    navigate(from);
    setInitializing(false);
  };



  const isValidEnvForUser = (envCookie, environments) => {
    const value =  environments.some(env => env.Id === envCookie);
    return value;
  };

  const validateAndSetCookie = async () => {
    console.log('validateAndSetCookie')

    try {
      const environments = await getEnvironmentsforUser();

      if (!envCookie || !isValidEnvForUser(envCookie, environments)) {
        const defaultEnv = environments[0]?.Id || null;
        if (defaultEnv) {
          setEnvCookie("ENV", defaultEnv, { maxAge: 86400 });
        }
      }
    } catch (error) {
      console.error("Error validating environment cookie:", error);
    }
  }

  useEffect(() => {
    const handleLogin = async () => {
      console.log('App.js useEffect', inProgress, isAuthenticated, accounts);

      try {
        if (inProgress === InteractionStatus.None && isAuthenticated) {
          setInitializing(true);
          const tokenResponse = await instance.acquireTokenSilent({
            scopes: config.scopes,
            account: accounts[0] // pick the first account
          })
              const accessToken = tokenResponse.accessToken;


              const r1 = await axios.post('/api/auth/Ad', { Token: accessToken, IdToken: tokenResponse.idToken }, { withCredentials: true });
              const { data: user } = await axios.post('/api/auth/GetUserByCookie', {}, { withCredentials: true });

              await handlePostLogin(user);
        } else {
          setInitializing(false);
        }
      } catch (error) {
        if(error.response.data.message == 'Max user count limit reached !'){
          showNotification({ message: t('maxUserLimit'), type: NotificationType.Error });
        }else{
          showNotification({ message: error.code, type: NotificationType.Error });
        }

        if (!!instance) {
          console.log('logging out');
          await instance.logoutPopup()
        }
        console.log(error); 
        setInitializing(false);
      }
    }

    handleLogin();
  }, [inProgress, isAuthenticated, instance, accounts]);


  if (initializing) {
    return (
      <form className="initializing-form">
        <div>
          {initializing && (
            <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          )}
        </div>
      </form>
    );
  }

  return (
    <>
        <Routes>
          <Route element={<Layout/>}>
            {/* Public routes */}
            <Route path="Login" element={<LoginForm/>}/>
            <Route path="LoginAgent" element={<LoginAgent/>}/>
            <Route path="CreateUser" element={<CreateUser/>}/>
            <Route path="Unauthorized" element={<Unauthorized/>}/>
            {/* Protected routes */}
            <Route element={<RequireAuth/>}>
              <Route index element={<Page/>}/>
              <Route path="EditUser" element={<EditUser/>}/>
              <Route path="EditTeam" element={<EditTeam/>}/>
              <Route path="Users" element={<UserList/>}/>
              <Route path='Teams' element={<ManageTeams/>}/>
              <Route path='CreateTeam' element={<CreateTeam/>}/>
              <Route path="ManageDocuments" element={<ManageDocuments/>}/>
              <Route path="Settings" element={<Settings/>}/>
            </Route>
          </Route>
        </Routes>
    </>
  );
}

export default App;
